














import { defineComponent, ref } from "@vue/composition-api";
import { PayeeInformation } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { PersonalInformation } from "@scrile/api-provider/dist/api/PersonalInformationProvider";
import { TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { UserPublicInformation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { UserVerification } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useTags from "@/hooks/useTags";
import useUserTags from "@/hooks/useUserTags";
import useUserVerification from "@/hooks/useUserVerification";
import providers from "@/lib/api";
import BasePage from "@/components/BasePage";
import PayeeInfoView from "./components/PayeeInfoView.vue";

export default defineComponent({
  name: "PagePayeeInfo",
  components: { PayeeInfoView, BasePage },
  setup() {
    const { authUserStrict, isFullCreator } = useAuthUser();
    const { findMyStatus } = useUserVerification();
    const { userTags, userContentTypes, userTagsGetData } = useUserTags();
    const { tags, getTags } = useTags([TagInfoType.USERS, TagInfoType.CONTENT_TYPE]);

    const loading = ref(false);
    const personalInformation = ref<PersonalInformation | null>(null);
    const userVerification = ref<UserVerification | null>(null);
    const publicInformation = ref<UserPublicInformation | null>(null);
    const payeeInformation = ref<PayeeInformation | null>(null);

    const getUserVerification = async () => {
      userVerification.value = await findMyStatus();
    };

    const getData = async () => {
      try {
        loading.value = true;
        const promises: Promise<any>[] = [
          providers.PersonalInformationProvider.find({ id: authUserStrict.value.id }).then(
            r => (personalInformation.value = r)
          ),
          providers.UserPublicDataProvider.userPublicInformationFind(authUserStrict.value.id).then(
            r => (publicInformation.value = r)
          ),
          getUserVerification(),
          getTags(),
          userTagsGetData(),
          findMyStatus(),
        ];
        if (isFullCreator.value) {
          promises.push(
            providers.PayeeInformationProvider.find({ id: authUserStrict.value.id }).then(
              r => (payeeInformation.value = r)
            )
          );
        }
        await Promise.all(promises);
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      personalInformation,
      publicInformation,
      payeeInformation,
      userVerification,
      userTags,
      userContentTypes,
      tags,
    };
  },
});
